"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _apis = require("../../../@apis");
var _TabContext = require("../contexts/TabContext");
var _AuthContext = require("../contexts/AuthContext");
var _TextInput = _interopRequireDefault(require("../../../@custom/TextInput"));
var _SimpleButton = _interopRequireDefault(require("../../../@custom/SimpleButton"));
var _InboxRequest = _interopRequireDefault(require("../../../@custom/InboxRequest"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function PasswordRecovery() {
  var _useAuth = (0, _AuthContext.useAuth)(),
    app = _useAuth.app,
    showMessage = _useAuth.showMessage,
    showSpinner = _useAuth.showSpinner,
    hideSpinner = _useAuth.hideSpinner;
  var _useContext = (0, _react.useContext)(_TabContext.TabContext),
    setTab = _useContext.setTab;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    errorMsg = _useState4[0],
    setErrorMsg = _useState4[1];

  /** @param {any} err */
  var handleError = function handleError(err) {
    var _err$response;
    var response = (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data;
    var errorMsg = errors[response];
    if (errorMsg) {
      setErrorMsg(errorMsg);
    } else {
      showMessage('Erro ao enviar e-mail de recuperação', /*#__PURE__*/_react["default"].createElement(_InboxRequest["default"], {
        error: err,
        additionalInfo: {
          email: email
        }
      }));
    }
  };
  var handleRecoverPassword = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            showSpinner();
            _context.prev = 1;
            _context.next = 4;
            return _apis.appcenterApi.auth.recoverPassword(email, app);
          case 4:
            setErrorMsg('');
            setTab('recoveryEmailSent');
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            handleError(_context.t0);
          case 11:
            _context.prev = 11;
            hideSpinner();
            return _context.finish(11);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8, 11, 14]]);
    }));
    return function handleRecoverPassword() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form-textBox"
  }, /*#__PURE__*/_react["default"].createElement("h1", null, "Esqueceu a senha?"), /*#__PURE__*/_react["default"].createElement("p", null, "Entre com o email cadastrado para receber instru\xE7\xF5es sobre recupera\xE7\xE3o da sua conta. \xC9 f\xE1cil e r\xE1pido!")), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Email",
    placeholder: "exemplo@gmail.com",
    onChange: function onChange(evt) {
      return setEmail(evt.target.value);
    },
    value: email
  }), errorMsg && /*#__PURE__*/_react["default"].createElement("p", {
    className: "Auth-right-form-error"
  }, "* ", errorMsg), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    fullWidth: true,
    onClick: handleRecoverPassword
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Enviar email de recupera\xE7\xE3o")), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Auth-right-form-centeredText"
  }, "N\xE3o \xE9 aqui?", ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: function onClick() {
      return setTab('login');
    }
  }, "Voltar \xE0 tela de login")));
}
var _default = PasswordRecovery;
exports["default"] = _default;
var errors = {
  'missing-user': 'Email é obrigatório',
  'user-not-found': 'Email não cadastrado'
};